import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that wraps a variant-aware specifications table.
 * Listens for variant update events and re-renders so variant-scoped metafield rows
 * (e.g. `variant.custom.ring_size`) reflect the newly selected variant.
 *
 * This section (Bespoke tabs) is a sibling of the product-information section that hosts
 * the variant picker, not a descendant of it, so the variant:update event never bubbles
 * into it — the listener has to sit on `document` rather than the closest section.
 */
class ProductSpecifications extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdate, this.updateSpecifications);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateSpecifications);
  }

  /**
   * Updates the specifications table.
   * @param {import('@theme/events').VariantUpdateEvent} event - The variant update event.
   */
  updateSpecifications = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSpecifications = event.detail.data.html.querySelector(
      `product-specifications[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newSpecifications) return;

    morph(this, newSpecifications, { childrenOnly: true });
  };
}

if (!customElements.get('product-specifications')) {
  customElements.define('product-specifications', ProductSpecifications);
}
